var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02222 11.6556C8.62222 14.8 11.2 17.3778 14.3444 18.9778L16.7889 16.5333C17.1 16.2222 17.5333 16.1333 17.9222 16.2556C19.1667 16.6667 20.5 16.8889 21.8889 16.8889C22.1836 16.8889 22.4662 17.006 22.6746 17.2143C22.8829 17.4227 23 17.7053 23 18V21.8889C23 22.1836 22.8829 22.4662 22.6746 22.6746C22.4662 22.8829 22.1836 23 21.8889 23C16.8792 23 12.0748 21.0099 8.53243 17.4676C4.99007 13.9252 3 9.12076 3 4.11111C3 3.81643 3.11706 3.53381 3.32544 3.32544C3.53381 3.11706 3.81643 3 4.11111 3H8C8.29469 3 8.5773 3.11706 8.78567 3.32544C8.99405 3.53381 9.11111 3.81643 9.11111 4.11111C9.11111 5.5 9.33333 6.83333 9.74444 8.07778C9.86667 8.46667 9.77778 8.9 9.46667 9.21111L7.02222 11.6556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e4cdef862dde6acda892d4cf49e03fc7.svg";
export { ForwardRef as ReactComponent };